import { Pipe, PipeTransform } from '@angular/core';
import { normalizeQuery } from './search-utils';

@Pipe({ name: 'filterByName' })
export class CompaniesNamePipe implements PipeTransform {
    transform(companies: any[], search: string): any[] {
        if (companies === undefined || search === '') {
            return companies;
        }
        let filteredCompanies = [];
        companies.map((company) => {
            if (normalizeQuery(company.name).includes(normalizeQuery(search))) {
                filteredCompanies.push(company);
            }
        });
        return filteredCompanies;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/companies-name.pipe.ts